import React, { useState, useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import AccountInfo from '../components/Account/AccountInfo.jsx';
import AccountLayout from '.././layouts/AccountLayout.jsx';
import AccountClasses from '../components/Account/AccountClasses.jsx';
import AccountPayments from '../components/Account/AccountPayments.jsx';

import firebase from '../firebase/firebaseConfig';
const Account = () => {
  const location = useLocation();

  const userUID = location.state ? location.state.userUID : null;

  const [user, setUser] = useState();
  const [toDisplay, settoDisplay] = useState('info');

  useEffect(() => {
    //Search the firestore and set a listener for any changes to the account
    if (!userUID) return;
    try {
      const unsubscribe = firebase
        .firestore()
        .collection('class_accounts')
        .doc(userUID)
        .onSnapshot((doc) => {
          setUser(doc.data());
        });

      return () => unsubscribe();
    } catch (e) {
      console.log(e);
    }
  }, []);

  const handleToDisplay = (value) => {
    settoDisplay(value);
  };
  if (!userUID) {
    return <Redirect to='/' />;
  }
  return (
    <div>
      <AccountLayout
        lang={user && user.lang}
        toDisplay={toDisplay}
        changeToDisplay={handleToDisplay}
      >
        {toDisplay === 'info' && <AccountInfo user={user} />}
        {toDisplay === 'payments' && <AccountPayments user={user} />}
        {toDisplay === 'classes' && <AccountClasses user={user} />}
      </AccountLayout>
    </div>
  );
};

export default Account;

/* <div className={classes.root}>
      <nav>
        <Drawer
          className={classes.drawer}
          variant='persistent'
          anchor='left'
          open
        >
          <List>
            {['Account', 'Classes', 'Payments'].map((text, index) => (
              <ListItem button key={text}>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            ))}.,
          </List>
        </Drawer>
      </nav>
      <main className={classes.content}>
        <AccountInfo />
      </main>
    </div> */
